module.exports = __webpack_public_path__ + "static/media/18_symbol_ruby_250k.10ae0bdb.png";